import React from "react";
import { Checkbox, PrimaryButton, Stack, Text } from "@fluentui/react";

const ContentSummariesActions = ({
    itemCount,
    selectedCount,
    parsedContentIdsCount,
    forceRegenerate,
    setForceRegenerate,
    isAdmin,
    isBusy,
    onGenerateSummaries,
}) => {
    return (
        <Stack
            horizontal
            wrap
            tokens={{ childrenGap: 16 }}
            styles={{ root: { alignItems: "center" } }}
        >
            <Text>
                Loaded: {itemCount} | Selected: {selectedCount} | Parsed IDs: {parsedContentIdsCount}
            </Text>
            <Checkbox
                label="Force AI regenerate even when a summary already exists"
                checked={forceRegenerate}
                onChange={(_, checked) => setForceRegenerate(!!checked)}
                disabled={!isAdmin}
            />
            <PrimaryButton
                text="Generate AI Summaries"
                onClick={onGenerateSummaries}
                disabled={!isAdmin || isBusy || (selectedCount === 0 && parsedContentIdsCount === 0)}
            />
            {!isAdmin && (
                <Text>
                    AI generation is limited to admins, but you can still review and edit summaries manually.
                </Text>
            )}
        </Stack>
    );
};

export default ContentSummariesActions;
